// Path: libs/core/shell/src/lib/layout/admin/services/admin-navigation.service.ts
import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { AdminNavItem } from '../../../models/admin-nav-item.model';
import { AdminRouteNavData } from '../models/admin-route-nav-data.model';
import { AdminLicenseService } from './admin-license.service';

//Service pra gerenciar rotas do menu com o app.route.ts
@Injectable({
  providedIn: 'root',
})
export class AdminNavigationService {
 constructor(
    private readonly router: Router,
    private readonly adminLicenseService: AdminLicenseService
  ) {}

  getAdminNavItems(): AdminNavItem[] {
    const adminRoute = this.router.config.find((route) => route.path === 'admin');

    if (!adminRoute?.children?.length) {
      return [];
    }

    return adminRoute.children
      .filter((route) => this.isNavigableAdminRoute(route))
      .map((route) => this.mapRouteToNavItem(route))
      .sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
  }

  private isNavigableAdminRoute(route: Route): boolean {
    if (!route.path || route.redirectTo) {
      return false;
    }

    const nav = this.extractNavData(route);

    if (!nav?.showInMenu) {
      return false;
    }

    return this.adminLicenseService.hasModuleLicense(nav.licenseKey);
  }

  private mapRouteToNavItem(route: Route): AdminNavItem {
    const nav = this.extractNavData(route)!;
    const baseOrder = nav.order ?? 999;

    return {
      label: nav.label,
      badge: nav.badge,
      icon: nav.icon,
      route: `/admin/${route.path}`,
      order: baseOrder,
      originalOrder: baseOrder,
    };
  }

  private extractNavData(route: Route): AdminRouteNavData | undefined {
    return route.data?.['nav'] as AdminRouteNavData | undefined;
  }
}